import { render, staticRenderFns } from "./ChannelList.vue?vue&type=template&id=6f23d12d"
import script from "./ChannelList.vue?vue&type=script&lang=js"
export * from "./ChannelList.vue?vue&type=script&lang=js"
import style0 from "./ChannelList.vue?vue&type=style&index=0&id=6f23d12d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports